<template>
    <div class="create-account-component">      

        <TermsPopup
          ref="termsPopupRef"
          :termsVisible="false"
        >
        </TermsPopup>

        <DxValidationGroup ref="validationGroupRef">
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class="dinesafe-label">Account Setup</div>
        </div>

        <div class='back-button'>
            <DxButton 
                icon="back"
                ref="btnBackRef" 
                type="normal"
                text="Back to LogIn"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>  

        <div class="dx-field-label dinesafe-label">Login Info</div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtEmail"
                placeholder="E-mail"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].Email"
            >       
                <DxValidator>
                    <DxRequiredRule message="E-mail is required" />
                </DxValidator>
            </DxTextBox>
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtPassword"
                placeholder="Password"  
                :show-clear-button="true"
                mode="password"
                width="300"
                stylingMode="underlined"
                :value.sync="accountInfo[0].Password"
            >       
                <DxValidator>
                    <DxRequiredRule message="Password is required" />
                    <DxPatternRule
                        :pattern="passwordPattern"
                        :message="this.$store.state.globals.passwordMessage"
                    />
                </DxValidator>
            </DxTextBox>        
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtConfirmPassword"
                placeholder="Confirm Password"
                :show-clear-button="true"
                mode="password"
                width="300"
                :value.sync="accountInfo[0].ConfirmPassword"
            >       
                <DxValidator>
                    <DxRequiredRule message="Confirm your password" />
                    <DxCustomRule
                        :validation-callback="comparePasswords"
                        type="custom"
                        message="Passwords do not match"
                    />
                </DxValidator>
            </DxTextBox>
        </div>

        <div class='create-account-input'>            
            <DxTextBox
                name="txtFirstName"
                placeholder="First Name"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].FirstName"
            >       
                <DxValidator>
                    <DxRequiredRule message="First Name is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtLastName"
                placeholder="Last Name"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].LastName"
            >       
                <DxValidator>
                    <DxRequiredRule message="Last Name is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtPhoneNumber"
                placeholder="Phone Number"  
                mask= '+1 (000) 000-0000'
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].PhoneNumber"
            >       
                <DxValidator>
                    <DxRequiredRule message="Phone Number is required" />
                </DxValidator>
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtAddress1"
                placeholder="Address 1"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].Address1"
            >       
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtAddress2"
                placeholder="Address 2"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].Address2"
            >       
            </DxTextBox>       
        </div>
        <div class='create-account-input'>            
            <DxTextBox
                name="txtCity"
                placeholder="City"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].City"
            >       
            </DxTextBox>       
        </div>

        <div class="create-account-input">
            <DxSelectBox
                :items="states"
                :value.sync="accountInfo[0].StateProvince"
                :show-clear-button="true"
                placeholder="State/Province"
            >       
            </DxSelectBox>
        </div>

        <div class='create-account-input postal-code'>            
            <DxTextBox
                name="txtPostalCode"
                placeholder="Postal Code"  
                :show-clear-button="true"
                width="300"
                :value.sync="accountInfo[0].PostalCode"
            >       
            </DxTextBox>       
        </div>

        <DxCheckBox
            text="Allow restaurants to see my information (optional)"
            :value.sync="accountInfo[0].ShareMyInfo"
        />

        <DxCheckBox
            text="Recieve updates from DineSafeVT"
            :value.sync="accountInfo[0].DineSafeVTNewsletters"
        />

        <div class="terms-and-conditions-container">
            <DxCheckBox
                text="I agree to the "
                :value.sync="accountInfo[0].AgreeToTerms"
            >
            </DxCheckBox>              
            <DxButton
                ref="btnTermsRef"
                text="Terms and Conditions"
                styling-mode="text"
                @click="btnTermsClick($event)"
                :element-attr="{
                    id: 'btnTermsAndConditions',
                    class: 'btn-terms-and-conditions',  //I set a class here so I can style the button like a hyperlink
                }"
            />
        </div>

        <div class='center-button'>
            <DxButton 
                ref="btnCreateAccountOkRef" 
                type="success"
                text="Create Account"
                styling-mode="contained" 
                :visible="true"
                width="180"
                :disabled="false"
                @click="btnCreateAccountOkClick"
            />
        </div>
        <!--<div class="dx-fieldset">
            <DxValidationSummary id="summary"/>
        </div>-->

        </DxValidationGroup>

        <PrivacyPolicyLink />
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import DxTextBox from "devextreme-vue/text-box";
    import service from '../../src/data/contact-info-data';
    import DxSelectBox from 'devextreme-vue/select-box';
    import DxValidator, { DxRequiredRule, DxCustomRule, DxPatternRule } from "devextreme-vue/validator";
    import DxValidationGroup from "devextreme-vue/validation-group";
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import notify from 'devextreme/ui/notify';
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    import TermsPopup from '../components/terms-and-conditions';
    import PrivacyPolicyLink from "../../src/components/privacy-policy-link";

    export default {
        components: {
            DxButton,
            DxTextBox,
            DxSelectBox,
            DxValidator, DxRequiredRule, DxCustomRule, DxPatternRule,
            DxValidationGroup,
            DxCheckBox,
            notify,
            DxValidationSummary,
            TermsPopup,
            PrivacyPolicyLink,
        },
        data() {
            const states = service.getStates();

            return {
                passwordPattern: /((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/,
                states: states,
                accountInfo:[
                    {
                        Email: null,
                        Password: null,
                        ConfirmPassword: null,
                        FirstName: null,
                        LastName: null,
                        PhoneNumber: null,
                        Address1: null,
                        Address2: '',
                        City: null,
                        StateProvince: "VT",
                        PostalCode: null,
                        ShareMyInfo: false,
                        AgreeToTerms: false,
                        DineSafeVTNewsletters: true,
                    }
                ]
            }
        },
        mounted(){
            
        },
        methods:{
            btnTermsClick(e){

            //Show the Terms and Conditions
            this.$refs.termsPopupRef.$data.termsVisibleYN = true;
            },
            comparePasswords(e) {
                console.log("comparePasswords");

                //Check if the value for the Password matches the value for Confirm Password
                return this.$data.accountInfo[0].Password == this.$data.accountInfo[0].ConfirmPassword;
                //return true;
            },
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            },
            btnCreateAccountOkClick(e){
                console.log("btnCreateAccountOkClick");
                
                //Validate the user inputs.
                if (!e.validationGroup.validate().isValid) {
                    return;
                }

                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'CreateUser',
                {       
                    Email: this.accountInfo[0].Email,
                    Password: this.accountInfo[0].Password,
                    FirstName: this.accountInfo[0].FirstName,
                    LastName: this.accountInfo[0].LastName,
                    PhoneNumber: this.accountInfo[0].PhoneNumber,          
                    Address: this.accountInfo[0].Address1,
                    Address1: this.accountInfo[0].Address2,
                    City: this.accountInfo[0].City,
                    StateProvince: this.accountInfo[0].StateProvince,
                    PostalCode: this.accountInfo[0].PostalCode,
                    ShareMyInfo: this.accountInfo[0].ShareMyInfo,
                }
                ).then(function(data){         
                    if(data.body != null && data.body != ''){
                        var responseData = JSON.parse(data.body);      

                        var userInfo = {LoggedIn: false, UserId: responseData[0].UserId};

                        //Navigate to the Admin page
                        //this.$router.push("/home");
                        console.log("User created, UserId: " + responseData[0].UserId);

                        var message = responseData[0].Message;

                        if(message == 'Success!'){
                            //Store the UserId, log the user in
                            this.$store.commit("setUserId", responseData[0].UserId);

                            //Store the UserId to LocalStorage
                            localStorage.dinesafeUser = JSON.stringify(userInfo);
    
                            //Reset the form
                            e.validationGroup.reset();
                            this.accountInfo[0].Address2 = '';

                            this.$router.push("/account-created");
                            /*notify(
                            {
                                message: "Account created", 
                                type:"success", 
                                width:100, 
                                displayTime: 2000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });*/
                        }
                        else if(message == 'The email provided already is associated with an active user in our system'){
                            notify(
                            {
                                message: this.accountInfo[0].Email + ' already exists', 
                                type:"error", 
                                width:100, 
                                displayTime: 3000,
                                position: {
                                    my: 'center center',
                                    at: 'center center',
                                }
                            });
                        }
                    }
                });
            },           
        }
    }
</script>

<style scoped>
    .dinesafe-label{
        padding-bottom:10px;
    }

    .continue-to-payment{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
    }

    .dx-field-label{
        width: 100%;
        padding-top: 20px;
    }

    .create-account-input {
        /* display: block */
        padding-bottom: 10px;
        padding-top:10px;

        margin:auto;
        max-width: 400px;
    }

    .back-button{
        padding-bottom: 0px; 
    }

    .postal-code{
        padding-bottom: 30px;
    }
</style>
